import { useState } from 'react';
import { Bubble } from './components/Bubble';
import { Panel } from './components/Panel';

export default function App() {
  const [open, setOpen] = useState(false);
  const cfg = window.grippyWidget;

  return open ? (
    <Panel onClose={() => setOpen(false)} />
  ) : (
    <Bubble
      onOpen={() => setOpen(true)}
      label="Chat with us"
      preview={cfg.persona.greeting}
    />
  );
}
